import React from "react";
import { render } from "react-dom";
import App from "./App";
import "./spotify.css";
// import "bootstrap/dist/css/bootstrap.css";

render(<App />, document.getElementById("root"));
